import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  upsellPill: {
    // We need both the flex (overrides button's inline-flex() and the margin-left
    // in cases when this pill is rendered alone in a container with greater width
    // than the pill itself. For example, this happens when the pill is rendered
    // inside the form.
    display: "flex",
    marginLeft: "auto",
    flexShrink: 0,
    backgroundColor: theme.colors.blue[1],
    color: theme.colors.blue[0],
    cursor: "pointer",
    paddingInline: theme.spacing.md,
    textTransform: "unset",

    ":disabled": {
      opacity: theme.other.disabled.opacity,
    },

    "&:hover:not(:disabled)": {
      backgroundColor: theme.colors.blue[0],
      color: "white",
      transition: `background-color ${theme.other.animation.duration.interaction}ms, color ${theme.other.animation.duration.interaction}ms`,
    },
  },
}));
